export class CheckoutcomApplePayProvider {
  constructor() {
    this.available = false;
    this.config = null;
    this.authorizedHandler = null;
    this.errorHandler = null;
  }

  async initialize({ currency, countryCode, displayName, publicKey }) {
    if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
      this.available = false;
      return;
    }

    this.publicKey = publicKey;
    this.config = {
      currency: currency || "USD",
      countryCode: countryCode || "US",
      displayName: displayName || "Online Store",
    };

    this.available = true;
  }

  isAvailable() {
    return this.available;
  }

  async show() {
    if (!this.config) return;

    const { amount, currency, countryCode, displayName } = this.config;

    const session = new ApplePaySession(3, {
      countryCode,
      currencyCode: currency,
      total: {
        label: displayName,
        amount: String(amount),
      },
      supportedNetworks: ["visa", "masterCard", "amex", "discover"],
      merchantCapabilities: ["supports3DS"],
      requiredShippingContactFields: ["email", "phone", "postalAddress", "name"],
    });

    session.onvalidatemerchant = async (event) => {
      try {
        const resp = await fetch("https://apme-api.checkout.com/vault-apme-api/payment-sessions", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.publicKey,
          },
          body: JSON.stringify({
            url: event.validationURL,
            display_name: displayName,
          }),
        });

        if (!resp.ok) {
          const body = await resp.text();
          console.error("Checkout.com Apple Pay validation failed:", resp.status, body);
          session.abort();
          if (this.errorHandler) this.errorHandler({ status: resp.status, body });
          return;
        }

        const merchantSession = await resp.json();
        session.completeMerchantValidation(merchantSession);
      } catch (e) {
        console.error("Merchant validation error:", e);
        session.abort();
        if (this.errorHandler) this.errorHandler(e);
      }
    };

    session.onpaymentauthorized = async (event) => {
      try {
        if (this.authorizedHandler) {
          await this.authorizedHandler(event);
        }
        session.completePayment(ApplePaySession.STATUS_SUCCESS);
      } catch (e) {
        console.error("Payment authorization error:", e);
        // A handler can attach ApplePayError instances to keep the sheet open
        // and tell the customer what to fix (e.g. an incomplete address).
        if (Array.isArray(e?.applePayErrors) && e.applePayErrors.length > 0) {
          session.completePayment({
            status: ApplePaySession.STATUS_FAILURE,
            errors: e.applePayErrors,
          });
        } else {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
        }
        if (this.errorHandler) this.errorHandler(e);
      }
    };

    session.oncancel = () => {
      if (this.errorHandler) this.errorHandler({ type: "cancel" });
    };

    session.begin();
  }

  unmount() {
    this.config = null;
    this.available = false;
  }

  onAuthorized(handler) {
    this.authorizedHandler = handler;
  }

  onError(handler) {
    this.errorHandler = handler;
  }
}
